export * from '@novel-segment/loaders/opencc';
import load from '@novel-segment/loaders/opencc';

export default load
